"use client";

import { useEffect, useRef } from "react";
import { useAuth, useClerk } from "@clerk/nextjs";
import { ENDED_SESSION_KEY, bindClerk, fetchEndReason, goToLogin, isEndingSession, markEnding } from "@/lib/sessionEnd";

/** Detecta cuando Clerk pierde la sesión sin aviso previo y lleva al login con el motivo real. */
export default function SessionWatcher() {
  const { isLoaded, isSignedIn, sessionId } = useAuth();
  const clerk = useClerk();
  const lastSession = useRef<string | null>(null);

  useEffect(() => {
    bindClerk(
      () => Boolean(clerk.session),
      (redirectUrl) => clerk.signOut({ redirectUrl })
    );
  }, [clerk]);

  useEffect(() => {
    if (!isLoaded) return;
    if (isSignedIn && sessionId) {
      lastSession.current = sessionId;
      return;
    }
    const previous = lastSession.current;
    lastSession.current = null;
    if (!previous || isEndingSession() || window.location.pathname.startsWith("/login")) return;
    markEnding();
    // Si Next llega antes a /login (refresh tras el cambio de sesión), el login
    // pide el motivo con este id.
    sessionStorage.setItem(ENDED_SESSION_KEY, previous);
    fetchEndReason(previous).then(goToLogin);
  }, [isLoaded, isSignedIn, sessionId]);

  return null;
}
